import { __assign } from '../_virtual/_tslib.js';
import * as elevation from './elevation.js';
export { elevation };
import * as deepBlue from './deepBlue.js';
export { deepBlue };
import * as grayBlue from './grayBlue.js';
export { grayBlue };
import * as neon from './neon.js';
export { neon };
import * as orange from './orange.js';
export { orange };
import * as red from './red.js';
export { red };
import { gray, grayA, blue, blueA, green, greenA, slate, slateA, purple, purpleA, whiteA, blackA, grayDark, grayDarkA, blueDark, blueDarkA, greenDark, greenDarkA, slateDark, slateDarkA, purpleDark, purpleDarkA } from '@radix-ui/colors';

var customColors = __assign(__assign(__assign(__assign(__assign(__assign({}, elevation), deepBlue), grayBlue), neon), orange), red);
var lightColors = Object.entries(customColors).filter(function (_a) {
  var colorName = _a[0];
  return !colorName.includes('Dark');
}).reduce(function (acc, _a) {
  _a[0];
    var colors = _a[1];
  return __assign(__assign({}, acc), colors);
}, __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, gray), grayA), blue), blueA), green), greenA), slate), slateA), purple), purpleA), whiteA), blackA));
var darkColors = Object.entries(customColors).filter(function (_a) {
  var colorName = _a[0];
  return colorName.includes('Dark');
}).reduce(function (acc, _a) {
  _a[0];
    var colors = _a[1];
  return __assign(__assign({}, acc), colors);
}, __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, grayDark), grayDarkA), blueDark), blueDarkA), greenDark), greenDarkA), slateDark), slateDarkA), purpleDark), purpleDarkA), whiteA), blackA));

export { darkColors, customColors as default, lightColors };
